import { gql } from '@apollo/client';

export const GET_DRIVER_WAREHOUSE_ID = gql`
    query GetDriverWarehouseId($driverAccountId: Long!) {
        getDriverWarehouseId(driverAccountId: $driverAccountId)
    }
`;

export interface GetDriverWarehouseIdResponse {
    getDriverWarehouseId: number | null;
}

export interface GetDriverWarehouseIdVariables {
    driverAccountId: number;
}
